// Import all question images
import q1Image from '@/assets/questions/q1-browse-search.jpg';
import q2Image from '@/assets/questions/q2-evaluate-credibility.jpg';
import q3Image from '@/assets/questions/q3-organize-store.jpg';
import q4Image from '@/assets/questions/q4-data-collection.jpg';
import q5Image from '@/assets/questions/q5-analyze-data.jpg';
import q6Image from '@/assets/questions/q6-digital-communication.jpg';
import q7Image from '@/assets/questions/q7-share-content.jpg';
import q8Image from '@/assets/questions/q8-digital-citizenship.jpg';
import q9Image from '@/assets/questions/q9-collaboration.jpg';
import q10Image from '@/assets/questions/q10-digital-etiquette.jpg';
import q11Image from '@/assets/questions/q11-content-creation.jpg';
import q12Image from '@/assets/questions/q12-modify-integrate.jpg';
import q13Image from '@/assets/questions/q13-copyright.jpg';
import q14Image from '@/assets/questions/q14-programming.jpg';
import q15Image from '@/assets/questions/q15-innovative-content.jpg';
import q16Image from '@/assets/questions/q16-device-protection.jpg';
import q17Image from '@/assets/questions/q17-privacy.jpg';
import q18Image from '@/assets/questions/q18-digital-dangers.jpg';
import q19Image from '@/assets/questions/q19-social-wellbeing.jpg';
import q20Image from '@/assets/questions/q20-identify-problems.jpg';
import q21Image from '@/assets/questions/q21-solve-problems.jpg';
import q22Image from '@/assets/questions/q22-tech-solutions.jpg';
import q23Image from '@/assets/questions/q23-self-development.jpg';
import q24Image from '@/assets/questions/q24-digital-evolution.jpg';

export type CompetenceArea =
  | "Information & Data Literacy"
  | "Communication & Collaboration"
  | "Digital Content Creation"
  | "Safety"
  | "Problem Solving";

export interface Question {
  id: number;
  area: CompetenceArea;
  question: string;
  questionAr: string;
  image: string;
  options: {
    value: number;
    label: string;
  }[];
}

export const questions: Question[] = [
  // Information & Data Literacy (5 questions)
  {
    id: 1,
    area: "Information & Data Literacy",
    question: "I can browse, search and filter data, information and digital content based on my needs.",
    questionAr: "يمكنني تصفح البيانات والمعلومات والمحتوى الرقمي والبحث عنها وتصفيتها بناءً على احتياجاتي.",
    image: q1Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 2,
    area: "Information & Data Literacy",
    question: "I can evaluate the credibility and reliability of sources of data, information and digital content.",
    questionAr: "يمكنني تقييم مصداقية وموثوقية مصادر البيانات والمعلومات والمحتوى الرقمي.",
    image: q2Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 3,
    area: "Information & Data Literacy",
    question: "I can organize, store and retrieve data, information and content in digital environments.",
    questionAr: "يمكنني تنظيم البيانات والمعلومات والمحتوى وتخزينها واسترجاعها في البيئات الرقمية.",
    image: q3Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 4,
    area: "Information & Data Literacy",
    question: "I understand how data is collected and used in digital environments.",
    questionAr: "أفهم كيف يتم جمع البيانات واستخدامها في البيئات الرقمية.",
    image: q4Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 5,
    area: "Information & Data Literacy",
    question: "I can analyze and interpret data to identify patterns and trends.",
    questionAr: "يمكنني تحليل البيانات وتفسيرها لتحديد الأنماط والاتجاهات.",
    image: q5Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },

  // Communication & Collaboration (5 questions)
  {
    id: 6,
    area: "Communication & Collaboration",
    question: "I can interact with others through a variety of digital technologies and understand appropriate digital communication means.",
    questionAr: "يمكنني التفاعل مع الآخرين من خلال مجموعة متنوعة من التقنيات الرقمية وفهم وسائل الاتصال الرقمي المناسبة.",
    image: q6Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 7,
    area: "Communication & Collaboration",
    question: "I can share data, information and digital content with others through appropriate digital technologies.",
    questionAr: "يمكنني مشاركة البيانات والمعلومات والمحتوى الرقمي مع الآخرين من خلال التقنيات الرقمية المناسبة.",
    image: q7Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 8,
    area: "Communication & Collaboration",
    question: "I can engage in citizenship through the use of public and private digital services.",
    questionAr: "يمكنني المشاركة في المواطنة من خلال استخدام الخدمات الرقمية العامة والخاصة.",
    image: q8Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 9,
    area: "Communication & Collaboration",
    question: "I can collaborate with others through digital technologies and manage conflicts in digital environments.",
    questionAr: "يمكنني التعاون مع الآخرين من خلال التقنيات الرقمية وإدارة النزاعات في البيئات الرقمية.",
    image: q9Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 10,
    area: "Communication & Collaboration",
    question: "I am aware of behavioral norms and know-how while using digital technologies and interacting in digital environments.",
    questionAr: "أنا على دراية بالمعايير السلوكية والمعرفة أثناء استخدام التقنيات الرقمية والتفاعل في البيئات الرقمية.",
    image: q10Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },

  // Digital Content Creation (5 questions)
  {
    id: 11,
    area: "Digital Content Creation",
    question: "I can create and edit digital content in different formats to express myself.",
    questionAr: "يمكنني إنشاء المحتوى الرقمي وتحريره بتنسيقات مختلفة للتعبير عن نفسي.",
    image: q11Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 12,
    area: "Digital Content Creation",
    question: "I can modify, refine and integrate information and content into an existing body of knowledge.",
    questionAr: "يمكنني تعديل المعلومات والمحتوى وتحسينها ودمجها في مجموعة المعرفة الموجودة.",
    image: q12Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 13,
    area: "Digital Content Creation",
    question: "I understand how copyright and licenses apply to data, information and digital content.",
    questionAr: "أفهم كيفية تطبيق حقوق النشر والتراخيص على البيانات والمعلومات والمحتوى الرقمي.",
    image: q13Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 14,
    area: "Digital Content Creation",
    question: "I can plan and develop instructions for a computing system to solve a given problem.",
    questionAr: "يمكنني التخطيط وتطوير تعليمات لنظام حوسبة لحل مشكلة معينة.",
    image: q14Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 15,
    area: "Digital Content Creation",
    question: "I can use digital tools to create innovative content and engage in creative processes.",
    questionAr: "يمكنني استخدام الأدوات الرقمية لإنشاء محتوى مبتكر والمشاركة في العمليات الإبداعية.",
    image: q15Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },

  // Safety (4 questions)
  {
    id: 16,
    area: "Safety",
    question: "I can protect devices and digital content, and understand risks and threats in digital environments.",
    questionAr: "يمكنني حماية الأجهزة والمحتوى الرقمي، وفهم المخاطر والتهديدات في البيئات الرقمية.",
    image: q16Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 17,
    area: "Safety",
    question: "I can protect personal data and privacy in digital environments and understand how to use and share personally identifiable information.",
    questionAr: "يمكنني حماية البيانات الشخصية والخصوصية في البيئات الرقمية وفهم كيفية استخدام ومشاركة المعلومات الشخصية القابلة للتحديد.",
    image: q17Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 18,
    area: "Safety",
    question: "I understand how to protect myself and others from digital dangers (e.g., cyberbullying, online harassment).",
    questionAr: "أفهم كيفية حماية نفسي والآخرين من المخاطر الرقمية (مثل التنمر الإلكتروني والمضايقات عبر الإنترنت).",
    image: q18Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 19,
    area: "Safety",
    question: "I am aware of digital technologies for social well-being and social inclusion.",
    questionAr: "أنا على دراية بالتقنيات الرقمية لتحقيق الرفاهية الاجتماعية والإدماج الاجتماعي.",
    image: q19Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },

  // Problem Solving (5 questions)
  {
    id: 20,
    area: "Problem Solving",
    question: "I can identify technical problems when operating devices and using digital environments.",
    questionAr: "يمكنني تحديد المشكلات التقنية عند تشغيل الأجهزة واستخدام البيئات الرقمية.",
    image: q20Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 21,
    area: "Problem Solving",
    question: "I can solve technical problems and identify gaps in my own digital competence.",
    questionAr: "يمكنني حل المشكلات التقنية وتحديد الفجوات في كفاءتي الرقمية الخاصة.",
    image: q21Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 22,
    area: "Problem Solving",
    question: "I can use digital technologies and media to solve problems and improve products/processes.",
    questionAr: "يمكنني استخدام التقنيات والوسائط الرقمية لحل المشكلات وتحسين المنتجات أو العمليات.",
    image: q22Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 23,
    area: "Problem Solving",
    question: "I can identify digital competence gaps and seek opportunities for self-development.",
    questionAr: "يمكنني تحديد فجوات الكفاءة الرقمية والبحث عن فرص للتطوير الذاتي.",
    image: q23Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  },
  {
    id: 24,
    area: "Problem Solving",
    question: "I can keep up-to-date with digital evolution and adapt to new digital tools and environments.",
    questionAr: "يمكنني مواكبة التطور الرقمي والتكيف مع الأدوات والبيئات الرقمية الجديدة.",
    image: q24Image,
    options: [
      { value: 1, label: "Not at all confident" },
      { value: 2, label: "Slightly confident" },
      { value: 3, label: "Moderately confident" },
      { value: 4, label: "Very confident" },
      { value: 5, label: "Extremely confident" }
    ]
  }
];
